import { useEffect, useState } from "react";
import axios from "axios";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Lock, Loader2, LogOut } from "lucide-react";
import { HeaderLogo } from "@/components/AnimatedLogo";
import { getAdminToken, setAdminToken, installAdminInterceptor } from "@/lib/adminAuth";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const formatError = (d) => (typeof d === "string" ? d : Array.isArray(d) ? d.map((e) => e.msg).join(" ") : "Connexion impossible");

const LoginForm = ({ onLogged }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const res = await axios.post(`${API}/auth/admin/login`, { email, password });
      setAdminToken(res.data.token);
      onLogged();
    } catch (err) {
      setError(formatError(err.response?.data?.detail));
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-b from-gray-50 to-white px-4">
      <form onSubmit={submit} className="w-full max-w-sm bg-white rounded-3xl shadow-xl p-8 space-y-4" data-testid="admin-login-form">
        <div className="flex justify-center mb-2"><HeaderLogo theme="contact" size="sm" showName={false} dark={false} /></div>
        <h1 className="text-xl font-bold text-center text-gray-900 flex items-center justify-center gap-2"><Lock className="w-5 h-5" /> Espace administrateur</h1>
        <div>
          <Label className="text-sm mb-1 block">Email</Label>
          <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="h-11" data-testid="admin-login-email" />
        </div>
        <div>
          <Label className="text-sm mb-1 block">Mot de passe</Label>
          <Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="h-11" data-testid="admin-login-password" />
        </div>
        {error && <p className="text-sm text-red-600" data-testid="admin-login-error">{error}</p>}
        <Button type="submit" disabled={loading} className="w-full h-11 bg-[#102692] hover:bg-[#0d1f75]" data-testid="admin-login-submit">
          {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Se connecter"}
        </Button>
      </form>
    </div>
  );
};

export const AdminGate = ({ children }) => {
  const [authed, setAuthed] = useState(null);

  useEffect(() => {
    installAdminInterceptor(() => setAuthed(false));
    if (!getAdminToken()) return setAuthed(false);
    axios.get(`${API}/auth/admin/me`).then(() => setAuthed(true)).catch(() => setAuthed(false));
  }, []);

  if (authed === null) return <div className="min-h-screen flex items-center justify-center"><Loader2 className="w-6 h-6 animate-spin text-[#102692]" /></div>;
  if (!authed) return <LoginForm onLogged={() => setAuthed(true)} />;
  return (
    <>
      {children}
      <button onClick={() => { setAdminToken(null); setAuthed(false); }}
        className="fixed bottom-4 right-4 z-50 flex items-center gap-2 px-4 py-2 rounded-full bg-white shadow-lg text-sm text-gray-700 hover:text-red-600"
        data-testid="admin-logout-btn">
        <LogOut className="w-4 h-4" /> Se déconnecter
      </button>
    </>
  );
};
